import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Admin from './pages/admin/Admin';
import CarDetail from './pages/CarDetail';
import CalculatorPage from './pages/CalculatorPage';
import AffiliatePage from './pages/AffiliatePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ReviewsPage from './pages/ReviewsPage';
import { TelegramBanner, FloatingSocial } from './components/SharedUI';
import { useFavicon } from './hooks/useAppHooks';

// سياق الوضع الليلي
export const ThemeContext = React.createContext({
  isDark: false,
  toggleTheme: () => {}
});

function AppContent() {
  useFavicon();
  const [isDark, setIsDark] = useState(false);

  // نظام التتبع التلقائي للأفلييت
  useEffect(() => {
    const search = window.location.search;
    if (search.includes('?')) {
      const params = new URLSearchParams(search);
      const ref = params.get('ref');
      if (ref) {
        localStorage.setItem('affiliate_ref', ref);
      }
    }
  }, []);

  // إدارة الوضع الليلي
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    } else {
      setIsDark(false);
      document.documentElement.classList.remove('dark');
    }
  }, []);

  const toggleTheme = () => {
    setIsDark(!isDark);
    if (!isDark) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <div className="flex flex-col min-h-screen">
        <TelegramBanner />
        <Navbar />
        <main className="flex-1 flex flex-col items-center w-full">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/calculator" element={<CalculatorPage />} />
            <Route path="/car/:id" element={<CarDetail />} />
            <Route path="/affiliate" element={<AffiliatePage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/dash-dz-2026/*" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <FloatingSocial />
      </div>
    </ThemeContext.Provider>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;